var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 29C17.5817 29 14 32.5817 14 37V91C14 95.4183 17.5817 99 22 99H106C110.418 99 114 95.4183 114 91V37C114 32.5817 110.418 29 106 29H22ZM106 30H22C20.252 30 18.6537 30.6407 17.427 31.7001L63.9997 68.3637L110.573 31.6998C109.346 30.6406 107.748 30 106 30ZM111.286 32.411L71.2329 63.9422L111.286 95.5891C112.354 94.3603 113 92.7556 113 91V37C113 35.2444 112.354 33.6397 111.286 32.411ZM63.696 69.3973L63.9997 69.6364L64.3135 69.3894L70.4955 64.634L110.573 96.3001C109.346 97.3594 107.748 98 106 98H22C20.2519 98 18.6535 97.3592 17.4268 96.2997L57.5037 64.634L63.696 69.3973ZM56.7664 63.9421L16.7137 32.4112C15.6462 33.64 15 35.2445 15 37V91C15 92.7554 15.6462 94.36 16.7137 95.5887L56.7664 63.9421Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 93,
    r: 20,
    fill: "#1EDF8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.869 87.3371L106.033 99.2056L100.164 93.8699L100.836 93.13L105.967 97.7944L116.131 86.6628L116.869 87.3371Z",
    fill: "#351648"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSuccess);
export default __webpack_public_path__ + "static/media/email-success.353f1e64.svg";
export { ForwardRef as ReactComponent };